"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Settings, ShieldCheck, RefreshCw } from "lucide-react";
export default function Excellence() {
  const header = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const features = [{
    label: "Precision Engineering",
    body: "Every installation is backed by rigorous structural standards, ensuring that our metal roofing and cladding systems provide superior thermal performance and weather resistance for decades."
  }, {
    label: "Premium Materials",
    body: "We utilize only high-grade ACM panels, James Hardie siding, and architectural stone veneer, sourced from industry-leading manufacturers to ensure a flawless, long-lasting finish."
  }, {
    label: "Lifecycle Integrity",
    body: "Our modular approach to exterior renovation allows for individual component maintenance and repair, ensuring your home remains protected and aesthetically stunning throughout its entire lifespan."
  }];
  return <section data-section-id="17422" id="why-metalline-stands-out" className="bg-background text-foreground ![padding:45px_0px_65px_0px]">
      <div className="mx-auto max-w-[1440px] px-6 md:px-12 lg:px-24">
        <div ref={header.ref} className="mx-auto max-w-[720px] text-center transition-all duration-[900ms] ease-[cubic-bezier(0.22,1,0.36,1)]" style={{
        opacity: header.isVisible ? 1 : 0,
        transform: header.isVisible ? "translateY(0)" : "translateY(16px)"
      }}>
          <h2 className="font-default font-semibold text-foreground text-[clamp(2rem,3.6vw,3.5rem)] leading-[1.08] tracking-[-0.015em]">
            Engineered for <em className="italic font-light">durability</em>
          </h2>
          <p className="font-default text-foreground/80 text-[clamp(1.0625rem,1.2vw,1.25rem)] leading-[1.6] mt-6 transition-all duration-[900ms] ease-[cubic-bezier(0.22,1,0.36,1)]" style={{
          opacity: header.isVisible ? 1 : 0,
          transform: header.isVisible ? "translateY(0)" : "translateY(16px)",
          transitionDelay: header.isVisible ? "120ms" : "0ms"
        }}>
            MetalLine Exteriors delivers premium construction through precision-focused engineering, high-performance materials, and a commitment to architectural integrity that stands the test of time.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-12 ![margin:65px_0px_0px_0px] md:grid-cols-3 md:gap-16">
          {features.map((feature, i) => {
          return <FeatureCell key={i} index={i} label={feature.label} body={feature.body} />;
        })}
        </div>
      </div>
    </section>;
}
function FeatureCell({
  index,
  label,
  body
}: {
  index: number;
  label: string;
  body: string;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const delay = index * 120;
  const Icon = index === 0 ? Settings : index === 1 ? ShieldCheck : RefreshCw;
  return <div data-index={index} ref={ref} className="group relative pt-12">
      <div className="absolute top-0 left-0 h-px bg-border group-hover:bg-primary transition-[width,background-color] ease-[cubic-bezier(0.22,1,0.36,1)] duration-[600ms] group-hover:duration-300" style={{
      width: isVisible ? "100%" : "0%",
      transitionDelay: isVisible ? `${delay}ms` : "0ms"
    }} />
      <div className="transition-all duration-[900ms] ease-[cubic-bezier(0.22,1,0.36,1)]" style={{
      opacity: isVisible ? 1 : 0,
      transform: isVisible ? "translateY(0)" : "translateY(16px)",
      transitionDelay: isVisible ? `${delay + 400}ms` : "0ms"
    }}>
        <Icon className="size-6 text-primary mb-6" strokeWidth={1.5} />
        <h4 className="font-default text-foreground text-base font-semibold leading-[1.4]">
          {label}
        </h4>
        <p className="font-default text-foreground/70 text-[0.9375rem] leading-[1.65] mt-6 max-w-[38ch]">
          {body}
        </p>
      </div>
    </div>;
}